import { ProfileProps } from './Profile';

/**
 * Returns the keys whose value differs between two field maps (in either
 * direction, so keys present on only one side count as changed), skipping any
 * key listed in `exclude`.
 */
export const getChangedFieldKeys = (
  baseline: Record<string, unknown>,
  current: Record<string, unknown>,
  exclude: string[] = [],
): string[] => {
  const excluded = new Set(exclude);
  const allKeys = new Set([...Object.keys(baseline), ...Object.keys(current)]);

  return [...allKeys].filter(
    key => !excluded.has(key) && baseline[key] !== current[key],
  );
};

interface ChangeUserDetailsProps extends Pick<ProfileProps, 'updateUser'> {
  firstName: string;
  lastName: string;
  emailAddress: string;
  initialEmailAddress: string;
  location?: string;
  department?: string;
  country?: string;
  state?: string | null;
}

export const changeUserDetails = async ({
  firstName,
  lastName,
  emailAddress,
  initialEmailAddress,
  location,
  department,
  country,
  state,
  updateUser,
}: ChangeUserDetailsProps) => {
  const shouldUpdateEmailAddress = emailAddress !== initialEmailAddress;
  const { error: apiError } = await updateUser({
    firstName,
    lastName,
    emailAddress: shouldUpdateEmailAddress ? emailAddress : undefined,
    locationId: location,
    departmentId: department,
    country,
    state,
  });

  if (apiError) {
    return {
      success: false,
    };
  }

  return {
    success: true,
    emailAddressUpdate: shouldUpdateEmailAddress,
  };
};
